"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
let VueToastify = class VueToastify extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.toasts = [];
    }
    formatMessage(message) {
        return message.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    }
    closeToast(toast) {
        // @ts-ignore
        const index = this.toasts.findIndex(t => t.id === toast.id);
        if (index !== -1) {
            this.toasts[index].removing = true;
            setTimeout(() => {
                this.toasts = this.toasts.filter(t => t.id !== toast.id);
            }, 400);
        }
    }
    showToast(id, msg, duration = 5000, theme) {
        const toast = { id, message: msg, progress: 100, interval: null, removing: false, theme: theme };
        let step = 100 / (duration / 100);
        this.toasts.push(toast);
        if (this.toasts.length > 3) {
            this.toasts[0].removing = true;
            setTimeout(() => {
                this.toasts.shift();
            }, 400);
        }
        toast.interval = setInterval(() => {
            toast.progress -= step;
            if (toast.progress <= 0) {
                clearInterval(toast.interval);
                this.closeToast(toast);
            }
            this.$forceUpdate();
        }, 100);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'top-end' })
], VueToastify.prototype, "position", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], VueToastify.prototype, "withPadding", void 0);
VueToastify = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { X: lucide_vue_next_1.X, Info: lucide_vue_next_1.Info, AlertTriangle: lucide_vue_next_1.AlertTriangle, CheckCircle: lucide_vue_next_1.CheckCircle }
    })
], VueToastify);
exports.default = VueToastify;
